<template>
<div id="getCard">
<div id="gacha">
    <div id="gachaAnime" @click="nextPage()">
        <img class="coin" src="../assets/img/gacha/gold.png" />

        <img id="Gbody" src="../assets/img/gacha/body.png" />
        <img id="Ghandle" src="../assets/img/gacha/handle.png" />
        
        <img id="blueBall" src="../assets/img/gacha/blue.png" />
        <img id="pinkBall" src="../assets/img/gacha/pink.png" />
        <img id="purpleBall" src="../assets/img/gacha/purple.png" />
        
        <img id="ball" src="../assets/img/gacha/ball.png" />
    </div>
</div>
</div>
</template>

<script>
export default{
    name: 'game',
    data() {
        return{
            next: '',
        }
    },
    created: function(){
        var self = this;
        self.$store.state.routeNext = setTimeout(function(){self.$router.push({ name: 'prize' });}, 12000);
    },
    methods:{
        nextPage: function(){
            var self = this;
            clearInterval(self.$store.state.routeNext);
            self.$router.push({ name: 'prize' });
        }
    }
}
</script>

<style scoped>
.prize{
    position: absolute;
    width: 60%;
    min-width: 100px;
    max-width: 300px;
    min-height: 200px;
    margin-top: 20px;
    left: 30%;
    top: 10px;
}
.goldImg{
    width: 20%;
}
.description {
  position: absolute;
  background: #19283c;
  padding: 4px 15px;
  border-radius: 20px;
  color: white;
  top: 80%;
  left: 40%;
}
.description::before {
  content: "";
  position: absolute;
  top: -17px;
  left: 15px;
  margin-right: 0;
  display: block;
  width: 15px;
  height: 15px;
  background: #19283c;
  border-radius: 50%;
}
.description::after {
  content: "";
  position: absolute;
  top: -25px;
  left: 25px;
  margin-right: 0;
  display: block;
  width: 8px;
  height: 8px;
  background: #19283c;
  border-radius: 50%;
}
#gacha{
    margin-top: -20px;
    width: 100%;
    height: 100vh;
    background: rgb(49, 77, 104);
    animation: gacha 5s both ;
    animation-delay: 13s;
    overflow: visible;
}
@keyframes gacha {
    0%{
        opacity: 1;
        z-index: 0;
    }
    100%{
        opacity: 0;
        z-index: -3
    }
}
#gachaAnime{
    width: 60%;
    min-width: 100px;
    max-width: 300px;
    min-height: 200px;
    left: 30%;
    position: relative;
    overflow: visible;
}
/* coin */
.coin{
    width: 80%;
    animation: coin-rotate 3s both ;
    position: absolute;
    top: 60px;
    left: 20px;
    border: none;
}
@keyframes coin-rotate{
    0%{
        transform: rotateY(0deg);
        opacity: 1;
    }
    25%,
    50%{
        transform: rotateY(360deg);
    }
    75%{
        transform: rotateY(0deg);
        opacity: 1;
    }
    100%{
        transform: rotateY(360deg);
        transform: scale(.3);
        opacity: 0;
    }
}

/* handle */
#Gbody{
    opacity: 1;
    width: 100%;
    animation: display 5s 2.8s both, swing 3s 8s forwards;
    position: absolute;
    left: 0;
    top: 0; 
    border: none;
}
#Ghandle{
    width: 100%;
    animation: gacha-handle 5s 2.8s both, swing 3s 8s forwards;
    position: absolute;
    display: inline-block;
    transform-origin: 50% 72%;
    left: 0;
    top: 0;
    border: none; 
}
@keyframes display{
0%{
    opacity: 0;
}
2%{
    opacity: 1;
}
100%{
    opacity: 1;
}}
@keyframes swing{
  0%{
      transform: rotate(0deg);
  }
  10%,30%,50%,70%,90%{
    transform: rotate(-10deg);
  }
  20%,40%,60%,80%{
    transform: rotate(10deg);
  }
  100%{
    transform: rotate(0deg);
}}
@keyframes gacha-handle{
    0%{
    opacity: 0;
    transform: rotate(360deg);
}
2%{
    opacity: 1;
}
10%{
    transform: rotate(300deg);
}
15%{
    transform: rotate(300deg);
}
25%{
    transform: rotate(240deg);
}
30%{
    transform: rotate(240deg);
}
40%{
    transform: rotate(180deg);
}
45%{
    transform: rotate(180deg);
}
55%{
    transform: rotate(120deg);
}
60%{
    transform: rotate(120deg);
}
70%{
    transform: rotate(60deg);
}
75%{
    transform: rotate(60deg);
}
85%{
    transform: rotate(0deg);
}
90%{
    transform: rotate(0deg);
}
100%{
    transform: rotate(0deg);
}}



/* ball 3 */
#blueBall{
    width: 100%;
    animation: display 5s 2.8s both, swingBlue 3s 8s forwards; 
    position: absolute;
    left: 0;
    top: 0;
    border: none;
}
#pinkBall{
    width: 100%;
    animation: display 5s 2.8s both, swingPink 3s 8s forwards;
    position: absolute;
    left: 0;
    top: 0;
    border: none;
}
#purpleBall{
    width: 100%;
    animation: display 5s 2.8s both, swingPurple 3s 8s forwards;
    position: absolute;
    left: 0;
    top: 0;
    border: none;
}
@keyframes swingBlue {
    0%{
    transform: rotate(0deg);
}
10%{
  transform: translate(7px, 5px) rotate(-10deg);
}
20%{
  transform: translate(0px, 5px) rotate(10deg);
}
30%{
  transform: rotate(-10deg);
}
40%{
  transform: translate(0px, 5px) rotate(10deg);
}
50%{
  transform: translate(5px, 5px) rotate(-10deg);
}
60%{
  transform: translate(0px, 5px) rotate(10deg);
}
70%{
  transform: translate(5px, 5px) rotate(-10deg);
}
80%{
  transform: rotate(10deg);
}
90%{
  transform: translate(5px, 5px) rotate(-10deg);
}
100%{
  transform: translate(0px, 0px) rotate(0deg);
}}
@keyframes swingPink {
    0%{
    transform: rotate(0deg);
}
10%{
  transform: translate(-3px, -5px) rotate(-10deg);
}
20%{
  transform: translate(0px, 5px) rotate(10deg);
}
30%{
  transform: translate(-3px, -5px) rotate(-10deg);
}
40%{
  transform: rotate(10deg);
}
50%{
  transform: translate(-3px, -5px) rotate(-10deg);
}
60%{
  transform: translate(0px, 5px) rotate(10deg);
}
70%{
  transform: translate(-3px, -5px) rotate(-10deg);
}
80%{
  transform: rotate(10deg);
}
90%{
  transform: translate(-3px, -5px) rotate(-10deg);
}
100%{
  transform: translate(0px, 0px) rotate(0deg);
}}
@keyframes swingPurple {
    0%{
    transform: rotate(0deg);
}
10%{
  transform: rotate(-10deg);
}
20%{
  transform: translate(-7px, 5px) rotate(10deg);
}
30%{
  transform: translate(0px, -7px) rotate(-10deg);
}
40%{
  transform: translate(-7px, 5px) rotate(10deg);
}
50%{
  transform: translate(0px, -7px) rotate(-10deg);
}
60%{
  transform: rotate(10deg);
}
70%{
  transform: rotate(-10deg);
}
80%{
  transform: translate(-7px, 5px) rotate(10deg);
}
90%{
  transform: translate(0px, -7px) rotate(-10deg);
}
100%{
  transform: translate(0px, 0px) rotate(0deg);
}}
/* ball */
#ball{
    width: 100%;
    animation: ball 3s both;
    animation-delay: 9.5s;
    position: absolute;
    left: 0;
    top: 20%;
    border: none;
}
@keyframes ball{
  0%{
    opacity: 0;
    transform: translate(0px, 50%) rotate(0deg) scale(.15);
}
30%{
    opacity: 1;
    transform: translate(0px, 50%) rotate(360deg) scale(.15);
}
60%{
    transform: translate(0px, 40%) rotate(-360deg) scale(.3);
}
90%{
    transform: translate(0px, 30%) rotate(360deg) scale(.6);
}
100%{
    opacity: 1;
    transform: translate(0px, 20%) rotate(-360deg) scale(.8);
}}
</style>